import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import conectaLogo from "../../assets/generales/logo.svg";
import "./Header.css";

const Header = () => {
  useEffect(() => {
    const header = document.querySelector(".home-header");
    const onScroll = () => {
      if (window.scrollY > 20) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="home-header sticky-top bg-black">
      <div className="container d-flex justify-content-between align-items-center py-2">
        <Link to="/">
          <img src={conectaLogo} alt="Conéctate Perú" className="logo-home" />
        </Link>
        <div>
          <Link to="/registrarme" className="btn btn-outline-light me-2">
            Registrarse
          </Link>
          <Link to="/login" className="btn btn-danger">
            Inicia sesión
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
